
export default function isClient() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}
